import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCountRegistrations } from "../../../api/listRegister";

// First, create the thunk
export const fetchCountRegistrations = createAsyncThunk(
  "count/fetchCountRegistrations",
  async () => {
    try {
      const response = await getCountRegistrations();
      return response.data;
    } catch (error) {
      
    }
  }
);

const initialState: any = {
  isFetching: true,
  pagination: {
    total: 0,
    per_page: 10,
    count: 0,
    current_page: 1,
    last_page: 1,
  },
  result: [],
  total: "0"
};

export const countRegistrationsSlide = createSlice({
  name: "countRegistrations",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchCountRegistrations.pending, (state) => {
      state.isFetching = true;
    });

    builder.addCase(fetchCountRegistrations.rejected, (state) => {
      state.isFetching = false;
    });

    builder.addCase(fetchCountRegistrations.fulfilled, (state, action) => {
      state.isFetching = false;
      state.pagination = action.payload?.pagination;
      state.result = action.payload?.data;
      state.total = action.payload?.total;
   
    });
  },
});

export const {} = countRegistrationsSlide.actions;

export default countRegistrationsSlide.reducer;
